import { createEntityAdapter } from "@ngrx/entity";
import { ProjectsTaskDFields } from "./dynamic-field.models";

export const taskFieldAdapter = createEntityAdapter<ProjectsTaskDFields>({
  selectId: (e) => e.projectId
});

export const taskFieldState = taskFieldAdapter.getInitialState();

export const taskFieldSelector = taskFieldAdapter.getSelectors();